interface Serializable<T> {
    deserialize(input: Object): T;
}

export class UserRecord implements Serializable<UserRecord> {
    public id: number;
    public first_name: string;
    public last_name: string;
    public email: string;
    public display_name: string;
    public username: string;
    public groups: any[];
    // public history: any[];
    public updated_by: string;
    public profile: any;
    public password?: string;
    public editable = false;
    public is_active:boolean;
    public icon_class = 'fa fa-pencil-square-o';
    public icon_delete = 'fa fa-remove';

    deserialize(data) {
        this.id = data.id;
        this.first_name = data.first_name;
        this.last_name = data.last_name;
        this.email = data.email;
        this.username = data.username;
        this.groups = data.groups;
        // this.history = data.user_history;
        this.is_active = data.is_active;
        this.updated_by = data.updated_by;
        this.profile = data.profile;
        if (this.last_name === null || this.first_name === null || this.last_name === '' || this.first_name === '') {
            this.display_name = this.username;
        } else {
            this.display_name = this.last_name + ', ' + this.first_name
        }
        return this;
    }
}
